import React, { useState, useEffect, useRef } from "react";
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import useNowPlayingData from "../../../hook/useNowPlayingData";
import "./radio-player-custom-v3.m.css";

const RadioPlayerCustomV3 = ({ pageType }) => {
  const { nowPlaying } = useNowPlayingData();
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1);
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);
  const [exitPlayer, setExitPlayer] = useState(false);
  const audioRef = useRef(null);
  const dispatch = useDispatch();
  const getState = useSelector((state) => state);
  const isRadiotHelsinkiClicked = get(getState, ["isRadiotHelsinkiClicked"], false);
  const isRadiotLahtiClicked = get(getState, ["isRadiotLahtiClicked"], false);
  const isRadiotRovaniemiClicked = get(getState, ["isRadiotRovaniemiClicked"], false);
  const isRadiotOuluClicked = get(getState, ["isRadiotOuluClicked"], false);
  const isRadiotYleisohjelmaClicked = get(getState, ["isRadiotYleisohjelmaClicked"], false);
  const isRadiotKajaniClicked = get(getState, ["isRadiotKajaniClicked"], false);
  const isRadiotTurkuClicked = get(getState, ["isRadiotTurkuClicked"], false);
  const isRadiotKemiClicked = get(getState, ["isRadiotKemiClicked"], false);
  const isRadiotTornioClicked = get(getState, ["isRadiotTornioClicked"], false);
  const isRadiotKokkolaClicked = get(getState, ["isRadiotKokkolaClicked"], false);
  const isRadiotKristiinankauppunkiClicked = get(getState, ["isRadiotKristiinankauppunkiClicked"], false);

  function getCookie(name) {
    const cookies = document.cookie.split('; ');

    for (let cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) return decodeURIComponent(value);
    }

    return null;
  }

  const setCookie = (name, value, days) => {
    //const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
  };

  const radioStations = [
    { station: "yleisohjelma", displayName: "Radio Dei" },
    { station: "helsinki", displayName: "Radio Dei Helsinki" },
    { station: "kajaani", displayName: "Radio Dei Kajaani" },
    { station: "tornio", displayName: "Radio Dei Kemi" },
    { station: "kruunupyy", displayName: "Radio Dei Kokkola" },
    { station: "kristiinankaupunki", displayName: "Radio Dei Kristiinankaupunki" },
    { station: "lahti", displayName: "Radio Dei Lahti" },
    { station: "oulu", displayName: "Radio Dei Oulu" },
    { station: "pori", displayName: "Radio Dei Pori" },
    { station: "rovaniemi", displayName: "Radio Dei Rovaniemi" },
    { station: "lapua", displayName: "Radio Dei Seinäjoki" },
    { station: "turku", displayName: "Radio Dei Turku" },
    { station: "lohja", displayName: "Radio Dei Lohja" },
  ];
  const [selectedStation, setSelectedStation] = useState(radioStations[0].station);
  useEffect(() => {
    if (pageType === "story-page") {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
        audioRef.current = null;
      }
      return;
    }

    if (audioRef.current) {
      audioRef.current.pause();
    }
    if (isRadiotHelsinkiClicked) {
      setCookie('currentRadioStation', "https://stream.dei.fi:8443/deiplus/helsinki");
      audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/helsinki`);
    } else if (isRadiotYleisohjelmaClicked) {
      setCookie('currentRadioStation', "https://stream.dei.fi:8443/deiplus/yleisohjelma");
      audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/yleisohjelma`);
    } else if (isRadiotKajaniClicked) {
      setCookie('currentRadioStation', "https://stream.dei.fi:8443/deiplus/kajaani");
      audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/kajaani`);
    } else if (isRadiotTurkuClicked) {
      setCookie('currentRadioStation', "https://stream.dei.fi:8443/deiplus/turku");
      audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/turku`);
    } else if (isRadiotOuluClicked) {
      setCookie('currentRadioStation', "https://stream.dei.fi:8443/deiplus/oulu");
      audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/oulu`);
    } else if (isRadiotRovaniemiClicked) {
      setCookie('currentRadioStation', "https://stream.dei.fi:8443/deiplus/rovaniemi");
      audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/rovaniemi`);
    } else if (isRadiotLahtiClicked) {
      setCookie('currentRadioStation', "https://stream.dei.fi:8443/deiplus/lohja");
      audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/lohja`);
    } else if (isRadiotTornioClicked) {
      /**above is ok */
      setCookie('currentRadioStation', "https://stream.dei.fi:8443/deiplus/lapua");
      audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/lapua`);
    } else if (isRadiotKokkolaClicked) {
      /* else if (isRadiotKemiClicked) {
        audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/tornio`);
      }*/
      setCookie('currentRadioStation', "https://vjs.zencdn.net/v/oceans.mp4");
      audioRef.current = new Audio(`https://vjs.zencdn.net/v/oceans.mp4`);
    } else if (isRadiotKristiinankauppunkiClicked) {
      audioRef.current = new Audio(
        `https://commondatastorage.googleapis.com/codeskulptor-demos/DDR_assets/Kangaroo_MusiQue_-_The_Neverwritten_Role_Playing_Game.mp3`
      );
    } else {
      const currentRadioStation = getCookie('currentRadioStation');

      if (!currentRadioStation) {
        audioRef.current = new Audio(`https://stream.dei.fi:8443/deiplus/${selectedStation}`);
        setCookie('currentRadioStation', `https://stream.dei.fi:8443/deiplus/${selectedStation}`);
      } else {
        audioRef.current = new Audio(`${currentRadioStation}`);
      }
    }
    audioRef.current.volume = volume;
    // comment following block as temporary solution to just mute radio on every audio changes
    /*  audioRef.current
     .play()
     .then(() => {
       setIsPlaying(true);
     })
     .catch((error) => {
       console.error("Autoplay failed:", error);
     });*/

    //temporary solution, when you uncomment above this block can be removed.
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
        audioRef.current = null;
      }
    };
  }, [
    pageType,
    selectedStation,
    isRadiotHelsinkiClicked,
    isRadiotLahtiClicked,
    isRadiotRovaniemiClicked,
    isRadiotOuluClicked,
    isRadiotYleisohjelmaClicked,
    isRadiotKajaniClicked,
    isRadiotTurkuClicked,
    isRadiotKemiClicked,
    isRadiotTornioClicked,
    isRadiotKokkolaClicked,
    isRadiotKristiinankauppunkiClicked,
  ]);
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume;
    }
  }, [volume]);

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };
  const togglePlayPause = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch((error) => {
        console.error("Play failed:", error);
      });
    }
    setIsPlaying(!isPlaying);
  };

  if (pageType === "story-page") return null;
  const handleExitPlayer = () => setExitPlayer(!exitPlayer);
  return !exitPlayer ? (
    <div styleName="fixed-container">
      <div styleName="radio-player">
        <div styleName="player-left">
          <div styleName="image-placeholder">
            <img src="/icons/radiodeilogo.jpg" alt="Album Cover" />
          </div>
          <div styleName="program-info">
            <h3>Maailma tarvitsee toivoa</h3>
          </div>
        </div>
        <div styleName="player-controls">
          <button onClick={togglePlayPause} styleName="play-pause">
            {isPlaying ? <i className="ri-pause-large-fill"></i> : <i className="ri-play-large-fill"></i>}
          </button>
          <div
            styleName="volume-control"
            onMouseEnter={() => setShowVolumeSlider(true)}
            onMouseLeave={() => setShowVolumeSlider(false)}
          >
            {volume === 0 ? (
              <div styleName="sound-icon">
                <i className="ri-volume-mute-fill ri-2x"></i>
              </div>
            ) : (
              <div styleName="sound-icon">
                <i className="ri-volume-up-fill ri-2x"></i>
              </div>
            )}
            {showVolumeSlider && (
              <div styleName="volume-slider-container">
                <div styleName="volume-slider-progress" style={{ height: `${volume * 100}%` }}></div>
                <input
                  type="range"
                  min="0"
                  max="1"
                  step="0.01"
                  value={volume}
                  onChange={handleVolumeChange}
                  styleName="volume-slider"
                />
              </div>
            )}
          </div>
          <div styleName="close-radio">
            <i className="ri-close-fill ri-2x" onClick={handleExitPlayer}></i>
          </div>
        </div>
        <div styleName="hide-info">
          <h3>Maailma tarvitsee toivoa</h3>
        </div>
      </div>
    </div>

  ) : (
    <div styleName="show-btn-wrapper">
      <div styleName="close-radio-icon">
        <img alt="radio-close" src="/icons/radio.svg" styleName="radio-icon" onClick={handleExitPlayer} />
      </div>
    </div>
  );
};
export default RadioPlayerCustomV3;
